import { useNavigate, useParams } from "react-router-dom";
import Loading from "shared/components/Spin";
import { useMutation, useQuery } from "shared/hooks/useApi";
import { UPDATE_EMAIL_TEMPLATE } from "utils/api/graphql/mutations/email";
import {
  GET_EMAIL_TEMPLATE,
  GET_EMAIL_TEMPLATES,
} from "utils/api/graphql/queries/emailTemplate";
import { SCREENS } from "utils/constants";
import View from "./View";

const Detail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const cancel = () =>
    navigate(SCREENS.PRIVATE.ADMIN.EMAIL_TEMPLATES.LIST.path);

  const [updateEmailTemplate] = useMutation(UPDATE_EMAIL_TEMPLATE, {
    refetchQueries: [
      {
        query: GET_EMAIL_TEMPLATES,
        awaitRefetchQueries: true,
      },
    ],
    onCompleted: () => {
      navigate(SCREENS.PRIVATE.ADMIN.EMAIL_TEMPLATES.LIST.path);
    },
  });

  const { data, loading, error } = useQuery(GET_EMAIL_TEMPLATE, {
    variables: { where: { id } },
  });

  const onSubmit = ({ createdDate, updatedDate, ...data }) => {
    return updateEmailTemplate({
      variables: {
        where: { id },
        data,
      },
    });
  };

  if (loading || error) return <Loading />;

  return <View onSubmit={onSubmit} data={data.emailTemplate} cancel={cancel} />;
};

export default Detail;
